import { CustomButton, CustomImage, CustomModal, useText, Text } from '@src/components';
import modalClose from '@src/assets/icons/icon-close.svg';
import '@src/styles/balanceUpload/excelUploadDeleteModal.scss';
import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import infoButton2 from '@src/assets/icons/np-warning-189701-000000.png';
import cardComp from '@src/assets/icons/card-comp.svg';
import { moneyFormat } from '@src/utils/utils';
import { loadBalanceDetailPriceUpdate } from '@src/store/slice/balanceUploadDetailSlice';
import { Table } from 'antd';
import iconDelete from '@src/assets/icons/icon_garbage.svg';
import { setShowLoader, setSpinText } from '@src/store/slice/appSettingsSlice';
import PropTypes from 'prop-types';

const ExcelUploadRowDeletedModal = ({
  modalVisible,
  handleModalVisible,
  decodedExcelFile,
  afterDelete,
  isCompliments = false,
}) => {
  const dispatch = useDispatch();
  const { selectedBalanceUploadDetails, excelUploadErrorMessages } = useSelector(
    (state) => state?.balanceUploadDetail,
  );
  const { currentLoadBalance } = useSelector((state) => state?.balanceUpload);
  const { selectedCustomer } = useSelector((state) => state?.customer);

  const handleClose = useCallback(
    (e) => {
      e.preventDefault();
      handleModalVisible(false);
    },
    [handleModalVisible],
  );

  const handleDelete = useCallback(
    async (e) => {
      await dispatch(setShowLoader(true));
      await dispatch(
        setSpinText(
          `1/${selectedBalanceUploadDetails.length} kayıt <br/> <span style="color:#d41414">siliniyor</span>`,
        ),
      );
      const data = {
        price: 0,
        idList: null,
        LoadBalanceId: currentLoadBalance?.id,
        cardNumber: selectedBalanceUploadDetails.map((item) => item.cardNumber),
        dontReFetch: true,
        customerId: selectedCustomer?.customerId,
      };
      await dispatch(loadBalanceDetailPriceUpdate(data));
      await dispatch(
        setSpinText(
          `${Math.round(selectedBalanceUploadDetails.length / 2)}/${selectedBalanceUploadDetails.length
          } kayıt <br/> <span style="color:#d41414">siliniyor</span>`,
        ),
      );
      handleModalVisible(false);
      await dispatch(
        setSpinText(
          `${selectedBalanceUploadDetails.length}/${selectedBalanceUploadDetails.length} kayıt <br/> <span style="color:#d41414">siliniyor</span>`,
        ),
      );
      await afterDelete(selectedBalanceUploadDetails);
      await dispatch(setSpinText(''));
      await dispatch(setShowLoader(false));
    },
    [selectedBalanceUploadDetails, currentLoadBalance, selectedCustomer, excelUploadErrorMessages],
  );

  const deleteColumns = [
    {
      title: <Text t="nameUpperCase" />,
      dataIndex: 'name',
      key: 'name',
      width: 100,
      align: 'center',
    },
    {
      title: <Text t="surnameUpperCase" />,
      dataIndex: 'surname',
      key: 'surname',
      width: 100,
      align: 'center',
    },
    {
      title: isCompliments ? <Text t="referenceNumber2" /> : <Text t="referenceNoUpperCase" />,
      dataIndex: 'refNo',
      key: 'refNo',
      width: 100,
      align: 'center',
    },
    {
      title: <Text t="cardNumber4" />,
      dataIndex: 'cardNumber',
      key: 'cardNumber',
      width: 140,
      align: 'center',
    },
    {
      title: isCompliments ? <Text t="amountVatIncludedUpperCase" /> : <Text t="totalPrice" />,
      dataIndex: 'price',
      key: 'price',
      width: isCompliments ? 100 : 85,
      align: 'center',
      render: (text) => <span>{moneyFormat(text, false)}</span>,
    },
  ];

  const totalPrice = useMemo(() => {
    let total = 0;
    selectedBalanceUploadDetails.forEach((item) => {
      total += item?.price || 0;
    });
    return total;
  }, [selectedBalanceUploadDetails]);

  return (
    <CustomModal
      className="excel-upload-delete-modal"
      width={1116}
      maskClosable={false}
      footer={false}
      title={<Text t="pleaseNote" />}
      visible={modalVisible}
      onCancel={handleClose}
      closeIcon={<CustomImage src={modalClose} />}
    >
      <div className="summary-info-container">
        <div className="summary-info-content">
          <div className="summary-info">
            <div className={'summary-text'}>
              <CustomImage src={infoButton2} className="error-title-icon" />
              <span>
                <Text t="youAreAboutToRemoveTheFollowingCards" />
              </span>
            </div>
            <div className="summary-list-content">
              <Table
                className="card-list-table"
                pagination={false}
                dataSource={selectedBalanceUploadDetails}
                columns={deleteColumns}
                rowKey={(record) => JSON.stringify(record)}
              />
            </div>
            {!isCompliments ? (
              <div className="summary-list-total">
                <div>
                  <Text t="total" />
                  <span className="red-text">{selectedBalanceUploadDetails.length}</span>{' '}
                  <Text t="orderTitle" />
                </div>
                <div>
                  <b>
                    <Text t="totalAmount" />
                  </b>{' '}
                  <span className="red-text" style={{ fontSize: '16px' }}>
                    {moneyFormat(totalPrice, true)}
                  </span>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
      {isCompliments ? null : <div className="long-line" />}
      <div
        className="footer-btn"
        style={{
          justifyContent: isCompliments ? 'center' : 'flex-end',
          paddingLeft: isCompliments ? 50 : 0,
          paddingTop: isCompliments ? 20 : 0,
          paddingBottom: '20px',
        }}
      >
        {isCompliments ? (
          <div className="summary-list-total" style={{ alignItems: 'flex-start', flex: 1 }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <CustomImage src={cardComp} style={{ marginRight: 5 }} />
              <Text t="total" />{' '}
              <span
                className="red-text"
                style={{ marginLeft: 3, marginRight: 3, color: '#3f4957' }}
              >
                {selectedBalanceUploadDetails.length}
              </span>{' '}
              <Text t="orderTitle" />
            </div>
            <div>
              <b style={{ color: '#3f4957' }}>
                <Text t="totalAmount" />
              </b>{' '}
              <span className="red-text" style={{ color: '#0f172a', fontSize: '16px' }}>
                {moneyFormat(totalPrice, true)}
              </span>
            </div>
          </div>
        ) : null}

        <button
          onClick={handleClose}
          style={{ backgroundColor: 'transparent', borderWidth: 0, cursor: 'pointer' }}
        >
          <b>
            <u>
              <Text t="giveUp" />
            </u>
          </b>
        </button>
        <CustomButton
          id="companyInformation-creditCards-cardDeleteModal-save-btn"
          className="save-btn"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          onClick={handleDelete}
        >
          <CustomImage style={{ marginRight: 5 }} className="icon-filter" src={iconDelete} />
          <Text t="deleteRecords" />
        </CustomButton>
      </div>
    </CustomModal>
  );
};

ExcelUploadRowDeletedModal.propTypes = {
  isCompliments: PropTypes.bool,
  modalVisible: PropTypes.any,
  handleModalVisible: PropTypes.any,
  decodedExcelFile: PropTypes.any,
  afterDelete: PropTypes.any,
};
export default ExcelUploadRowDeletedModal;
